import { render } from "./BasketItem.vue?vue&type=template&id=2a31f424"
import script from "./BasketItem.vue?vue&type=script&lang=js"
export * from "./BasketItem.vue?vue&type=script&lang=js"

import "./BasketItem.vue?vue&type=style&index=0&id=2a31f424&lang=scss"

import exportComponent from "/codebuild/output/src4174910631/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__